import React from 'react';

/**
 * Warning modal shown before auto logout due to inactivity
 *
 * @param {boolean} show - Whether to show the modal
 * @param {number} remainingSeconds - Seconds remaining before logout
 * @param {function} onContinue - Callback when user clicks "Stay Logged In"
 */
const IdleTimeoutWarning = ({ show, remainingSeconds, onContinue }) => {
  if (!show) return null;

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 animate-bounce-in">
        <div className="bg-yellow-500 text-white px-6 py-4 rounded-t-xl flex items-center gap-3">
          <svg className="w-8 h-8 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h2 className="text-xl font-bold">Session Timeout Warning</h2>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-700 mb-4">
              You have been inactive for a while. For security reasons, you will be automatically logged out soon.
            </p>

            <div className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 text-center">
              <p className="text-sm text-gray-600 mb-2">Time remaining:</p>
              <p className="text-4xl font-bold text-yellow-600">
                {minutes}:{seconds.toString().padStart(2, '0')}
              </p>
            </div>
          </div>

          <button
            onClick={onContinue}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 font-semibold text-lg transition-colors flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Stay Logged In
          </button>

          <p className="text-xs text-gray-500 text-center mt-4">
            Click the button above or move your mouse to stay logged in
          </p>
        </div>
      </div>
    </div>
  );
};

export default IdleTimeoutWarning;
